document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('a[href^="#"]:not(.filterset__reset)').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
